/**
 * @generated SignedSource<<524e8f5d7b37a43fd1ca8f5ee906c7ef>>
 * @relayHash 7fe01343636a1cc8e3587d1c0025997f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105

import type { ConcreteRequest } from 'relay-runtime';
export type ContentOwnerPopupComponentContentOwnerQuery$variables = {
  contentId: string;
};
export type ContentOwnerPopupComponentContentOwnerQuery$data = {
  readonly singleContent: {
    readonly history: {
      readonly createdBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
      } | null | undefined;
      readonly ownedBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type ContentOwnerPopupComponentContentOwnerQuery = {
  response: ContentOwnerPopupComponentContentOwnerQuery$data;
  variables: ContentOwnerPopupComponentContentOwnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentOwnerPopupComponentContentOwnerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v5/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v5/*: any*/)
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentOwnerPopupComponentContentOwnerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v6/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v6/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "7fe01343636a1cc8e3587d1c0025997f",
    "id": "70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105",
    "metadata": {},
    "name": "ContentOwnerPopupComponentContentOwnerQuery",
    "operationKind": "query",
    "text": "query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdBy{__typename,displayName,...on KnownUser{accountId}},ownedBy{__typename,displayName,...on KnownUser{accountId}}}}}"
  }
};
})();

(node as any).hash = "ab500ff679b71481a192bc88337cadcd";

export default node;
